/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-26 15:32:33
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-26 16:01:26
 */
import request from '@/utils/request';
import { AjaxMethod } from '@/utils/dataMap';

//原首页接口
// 获取弹框信息
export const getPopup = params => {
	return request({
		url: '/api/team-conf/get-popup',
		data: params,
		method: AjaxMethod.post,
	});
};
// 首页工作台（待办事项）
export const getHomeWorkBench = params => {
	return request({
		url: '/api/partner-result/home-work-bench-v1',
		data: params,
		method: AjaxMethod.post,
	});
};

// 商品转换路径
export const getProductConversion = params => {
	return request({
		url: '/api/partner-result/product-conversion',
		data: params,
		method: AjaxMethod.post,
	});
};

// 达人转化分析
export const getTalentAnalyse = params => {
	return request({
		url: '/api/partner-result/talent-analyse',
		data: params,
		method: AjaxMethod.post,
	});
};

// 首页工作台登录信息
export const getHomeLoginInfo = params => {
	return request({
		url: '/api/partner-result/home-login-info',
		data: params,
		method: AjaxMethod.post,
	});
};

// 获取公共
export const getAnnouncementList = params => {
	return request({
		url: '/api/announcement/list',
		data: params,
		method: AjaxMethod.post,
	});
};

// 直播日历接口
export const calendarList = params => {
	return request({
		url: '/api/live/calendar-list',
		data: params,
		method: AjaxMethod.post,
	});
};

// 直播日历接口
export const calendarDetail = params => {
	return request({
		url: '/api/live/calendar-detail',
		data: params,
		method: AjaxMethod.post,
	});
};
//是否授权新应用
export const getAuthStatus = (params, notOrigin = true) => {
	return request({
		url: '/api/institution/check-new-authorize',
		params,
		method: AjaxMethod.get,
		notOrigin,
	});
};
//获取数据大屏地址
export const getScreenInfo = (params, notOrigin = true) => {
	return request({
		url: '/api/screen/get-info',
		params,
		method: AjaxMethod.get,
		notOrigin,
	});
};

// 数据概览
export const dataOverview = params => {
	return request({
		// url: '/api/partner-result/results-info-v2',
		url: '/api/stat/data-overview',
		data: params,
		method: AjaxMethod.post,
	});
};

// 达人转化
export const talentTransformation = params => {
	return request({
		url: '/api/workbench-anchor/anchor-analyse',
		data: params,
		method: AjaxMethod.post,
	});
};

// 样品转化
export const getSampleConversion = params => {
	return request({
		url: '/api/partner-result/sample-analyse',
		data: params,
		method: AjaxMethod.post,
	});
};

// 达人排行
export const getAnchorRank = params => {
	return request({
		url: '/api/ranking/anchor-home',
		data: params,
		method: AjaxMethod.post,
	});
};

// 商品排行
export const getProductRank = params => {
	return request({
		url: '/api/ranking/product-home',
		data: params,
		method: AjaxMethod.post,
	});
};

// 二级团长排行
export const getInstitutionRank = params => {
	return request({
		url: '/api/ranking/institution-home',
		data: params,
		method: AjaxMethod.post,
	});
};

// 员工排行
export const getStaffRank = params => {
	return request({
		url: '/api/ranking/user-home',
		data: params,
		method: AjaxMethod.post,
	});
};

// 超佣团弹窗已读接口
export const popRead = params => {
	return request({
		url: '/api/popup-notify/pop-read',
		data: params,
		method: AjaxMethod.post,
	});
};
// 超佣团获取最新弹窗接口
export const getNewPop = params => {
	return request({
		url: '/api/popup-notify/get-new-pop',
		params,
		method: AjaxMethod.get,
	});
};
